/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BladderIrrigationReverseAliases {
  AUTOCOMPLETE_REASON_LIST = 'autocomplete-reason-list',
  BLADDER_IRRIGATION_PANEL = 'bladder-irrigation-panel',
  BLADDER_IRRIGATION_REVERSE_FORM = 'bladder-irrigation-reverse-form',
  BLADDER_IRRIGATION_REVERSE_LAYOUT = 'bladder-irrigation-reverse-layout',
  FETCH_REASON = 'fetch-reason',
  FIELD_REASON = 'field-reason',
  HEADER_FRAGMENT_REVERSE = 'header-fragment-reverse',
  LOADER = 'loader',
  MAPPER_REVERSE = 'mapper-reverse',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  PANEL_LOADER = 'panel-loader',
  REVERSE_BLADDER_IRRIGATION_CONTEXTUAL_BAR = 'reverse-bladder-irrigation-contextual-bar',
  TEXT_REVERSE = 'text-reverse',
}
export { BladderIrrigationReverseAliases };
